import {
  SHOW_MEAL_CARD_MODAL,
  HIDE_MEAL_CARD_MODAL,
  MEAL_CARD_ISSUERS_REQUEST,
  MEAL_CARD_ISSUERS_SUCCESS,
  MEAL_CARD_ISSUERS_FAILURE,
} from '../actions/types';

const initialState = {
  issuers: [],
  showModal: false,
  error: null,
};

export default function mealCardReducer(state = initialState, action = {}) {
  switch (action.type) {
    case MEAL_CARD_ISSUERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MEAL_CARD_ISSUERS_SUCCESS:
      return {
        ...state,
        issuers: action.payload.data,
        loading: false,
      };
    case MEAL_CARD_ISSUERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          status: action.status,
          message: action.message,
          type: action.payload.type,
        },
      };
    case SHOW_MEAL_CARD_MODAL:
      return {
        ...state,
        showModal: true,
      };
    case HIDE_MEAL_CARD_MODAL:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
